type SearchType = "simple" | "advanced";

interface IGTagSearchPayload extends Gtag.EventParams {
    searchType: SearchType,
    hasCemeteryId: boolean,
    cityQueryLength: number,
    surnameQueryLength: number,
    maidenSurnameQueryLength: number,
    nameQueryLength: number,
    sectionQueryLength?: number,
    wayQueryLength?: number,
    numberQueryLength?: number,
    dateOfBirthFromUsed?: boolean,
    dateOfBirthToUsed?: boolean,
    dateOfDeathFromUsed?: boolean,
    dateOfDeathToUsed?: boolean
}

interface IGTagSearchMoreResultsPayload extends IGTagSearchPayload {
    searchOffset: number,
    searchedCid: number
}

export interface IGTagSearchResultClickPayload extends Gtag.EventParams {
    clickedCid: number,
    searchTarget: "cemetery" | "grave"
}

export function getGTagSearchPayload():IGTagSearchPayload {
    let payload:IGTagSearchPayload = {
        searchType: "simple",
        hasCemeteryId: (document.querySelector("input#obec") as HTMLInputElement)?.hasAttribute("data-cemetery-id"),
        cityQueryLength: (document.querySelector("input#obec") as HTMLInputElement)?.value.trim().length ?? 0,
        surnameQueryLength: (document.querySelector("input#priezvisko") as HTMLInputElement)?.value.trim().length ?? 0,
        maidenSurnameQueryLength: (document.querySelector("input#rodnePriezvisko") as HTMLInputElement)?.value.trim().length ?? 0,
        nameQueryLength: (document.querySelector("input#meno") as HTMLInputElement)?.value.trim().length ?? 0,
    };
    if (!document.getElementById("simpleSearchToggle").classList.contains("karta-collapsed")) { 
        payload.searchType = "advanced";
        payload.sectionQueryLength = (document.querySelector("input#sektor") as HTMLInputElement)?.value.trim().length ?? 0;
        payload.wayQueryLength = (document.querySelector("input#rad") as HTMLInputElement)?.value.trim().length ?? 0;
        payload.numberQueryLength = (document.querySelector("input#cislo") as HTMLInputElement)?.value.trim().length ?? 0;
        payload.dateOfBirthFromUsed = (document.querySelector("input#datumNarodeniaOd") as HTMLInputElement)?.value.trim().length > 0;
        payload.dateOfBirthToUsed = (document.querySelector("input#datumNarodeniaDo") as HTMLInputElement)?.value.trim().length > 0;
        payload.dateOfDeathFromUsed = (document.querySelector("input#datumUmrtiaOd") as HTMLInputElement)?.value.trim().length > 0;
        payload.dateOfDeathToUsed = (document.querySelector("input#datumUmrtiaDo") as HTMLInputElement)?.value.trim().length > 0;
    }
    return payload;
}

export function getGTagSearchMoreResultsPayload(clickedDiv: HTMLDivElement): IGTagSearchMoreResultsPayload {
    return { 
        ...getGTagSearchPayload(),
        searchOffset: +clickedDiv.getAttribute("data-from-id"),
        searchedCid: +clickedDiv.getAttribute("data-cemetery-id")
    };
}
